export default __webpack_public_path__ + "static/media/ketovacation@3x.0d967a88.jpg";